let activeEnv = process.env.PROJECT_ENV && process.env.PROJECT_ENV.trim();
let activePreview = process.env.CF_PREVIEW && process.env.CF_PREVIEW.trim();
const contentfulEnvironment =
  (process.env.CONTENTFUL_ENVIRONMENT &&
    process.env.CONTENTFUL_ENVIRONMENT.trim()) ||
  (process.env.CF_ENVIRONMENT && process.env.CF_ENVIRONMENT.trim()) ||
  'PANTENE_BR_PT';
if (!activeEnv) {
  activeEnv = 'development';
}
if(!activePreview) {
  activePreview = false;
}
module.exports = {
  ...require('./' + activeEnv.trim() + '.json'),
  env: activeEnv,
  inActiveSessionExpire: 1800000,
  ageRestrictionExpirationDays: 1,
  contentful: {
    spaceId: "27loxu94eo0x",
    environment: contentfulEnvironment,
    endpoint: "https://graphql.contentful.com/content/v1/spaces/{spaceId}/environments/{environment}?query={query}&access_token={accessToken}",preview: activePreview
  },
  screenWidth: {
    smartPhoneWidth: 991,
    tabPhoneWidthEnd: 1023,
    tabWidthStart: 768,
    tabWidthFilter: 1022,
    imageSetDesktopWidth: '',
    imageSetTabletWidth: '768w',
    imageSetMobileWidth: '375w',
  },
  imageGallery: {
    imageGalleryWidth: {
      smartPhoneWidth: 767,
    },
    imageGallerySizes: {
      thumbnailImage: {
        w: 118,
        h: 118,
      },
      selectedImage: {
        w: 460,
        h: 460,
      },
      magnifiedImage: {
        w: 1210,
        h: 1210,
      },
      modalImage: {
        w: 1210,
        h: 1210,
      },
    },
  },
};
